/** @format */

import React from 'react'
import { Icon, Button, Form, FormItem, Input } from '@king-design/react'
import styled from 'styled-components'
import { cloneDeep, trim } from 'lodash'
interface AlarmCallBackProps {
  value?: string[]
  onChange?: (data: string[]) => void
  maxLength?: number
  style?: React.CSSProperties
  className?: string
}

const AlarmCallBack: React.FC<AlarmCallBackProps> = ({
  value = [],
  onChange,
  maxLength = 10,
  style,
  className
}) => {
  return (
    <div className={className} style={style || {}}>
      <Form labelWidth={0}>
        {Array.isArray(value)
          ? value.map((item, index) => (
              <FormItem
                key={index}
                hideLabel
                rules={{
                  required: true,
                  isWebAddress: true,
                  unique: val => {
                    const validate = value.every((item, i) => index === i || val !== item)
                    if (!validate) {
                      return '告警回调不能重复'
                    } else if (value.indexOf(',') >= 0) {
                      return '告警回调不支持英文逗号'
                    } else {
                      return true
                    }
                  }
                }}
                value={item}
                messages={{
                  required: '请输入告警回调'
                }}
              >
                <Input
                  value={item}
                  placeholder="填写公网可访问到的URL作为回调接口地址,例如:https://console.ksyun.com:8080/callback"
                  onChangeValue={val => {
                    const clone = cloneDeep(value)
                    clone[index] = trim(val)
                    onChange && onChange(clone)
                  }}
                />
                <a
                  onClick={() => {
                    const clone = cloneDeep(value)
                    clone.splice(index, 1)
                    onChange && onChange(clone)
                  }}
                >
                  删除
                </a>
              </FormItem>
            ))
          : null}
      </Form>
      <p className="add_callback">
        <Button
          disabled={value.length >= maxLength}
          type="link"
          onClick={() => {
            onChange([...value, ''])
          }}
        >
          <Icon color="#0091ea" className="ion-plus-round" />
          添加回调
        </Button>
      </p>
    </div>
  )
}

export default styled(AlarmCallBack)`
  .k-form-item {
    &:last-child {
      padding-bottom: 12px;
    }
    .k-form-content {
      width: 100%;
      display: flex;
      align-items: center;
      .k-input {
        width: calc(100% - 32px);
        margin-right: 8px;
      }
      .k-form-error {
        top: 32px;
      }
    }
  }
  .add_callback {
    line-height: 32px;
    margin-bottom: 0;
  }
`
